<template>
  <div class="item">
    <div class="question flex flex-align-center flex-space-between" @click="clickQuestion">
      <div class="flex">
        <img alt="" class="img" src="@/views/serverQa/components/img/Frame2757@2x.png">
        <div class="text">
          {{ data.q }}
        </div>
      </div>
        <img
          v-if="!showAnswer"
          alt=""
          class="button"
          src="@/views/serverQa/components/img/down.png"
        >
        <img
          v-else
          alt=""
          class="button"
          src="@/views/serverQa/components/img/up.png"
        >
    </div>
    <div v-if="showAnswer" class="answer">
      <div class="flex">
        <img alt="" class="img" src="@/views/serverQa/components/img/Frame2758@2x.png">
        <div class="text">
          {{ data.a }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherCustomerQuestionItem',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      /** 是否显示答案 */
      showAnswer: false,
    }
  },
  watch: {
    data: {
      handler() {
        this.showAnswer = false
      },
      deep: true,
    },
  },
  methods: {
    /** 点击问题 */
    clickQuestion() {
      this.showAnswer = !this.showAnswer
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  padding: 16px 12px;
}

.img {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
}

.question {
  font-size: 15px;
  font-weight: 400;
  color: #333333;

  .button {
    width: 16px;
    height: 16px;
    display: block;
    flex-shrink: 0;
    align-self: flex-start;
  }
}

.text {
  margin-left: 5px;
}

.answer {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-top: 12px;
}
</style>
